import Vue from 'vue'
import { get, findLastIndex } from 'lodash'

export const STATUS_DICTIONARY = {
  completed: {
    icon: 'fas fa-check',
    color: 'positive'
  },
  not_reached: {
    icon: 'fas fa-pause',
    color: 'grey-4'
  },
  not_applicable: {
    icon: 'fas fa-ban',
    color: 'faded'
  },
  dismissed: {
    icon: 'fas fa-times',
    color: 'negative'
  },
  pending: {
    icon: 'fas fa-play',
    color: 'warning'
  }
}

const MILESTONE_ACTIONS = {
  show_progress_bar_settings: {
    route: { name: 'workflow-settings' },
    label: 'Workflow Settings'
  },
  show_subscription_period_settings: {
    event: 'openEditSubPeriodModal',
    label: 'Edit subscription period'
  }
}
const MILESTONE_MIXIN = Vue.mixin({
  computed: {
    MILESTONE_ACTIONS() {
      return MILESTONE_ACTIONS
    }
  },
  methods: {
    getStatusIndicator(event) {
      return get(STATUS_DICTIONARY, `${event.status}.icon`, 'fas fa-radiation')
    },
    getStatusColor(event) {
      return get(STATUS_DICTIONARY, `${event.status}.color`, 'negative')
    },
    getLastCompletedMarker(milestones) {
      let lastCompleted = findLastIndex(milestones, x => x.status === 'completed' || x.status === 'dismissed')
      return lastCompleted >= 0 ? lastCompleted : 0
    },
    statusIsPresentIn(status, statusesToCheck) {
      return statusesToCheck.includes(status)
    },
    getPosition(el) {
      let xPosition = 0
      let yPosition = 0

      while (el) {
        if (el.tagName === 'BODY') {
          // deal with browser quirks with body/window/document and page scroll
          let xScrollPos = el.scrollLeft || document.documentElement.scrollLeft
          let yScrollPos = el.scrollTop || document.documentElement.scrollTop

          xPosition += el.offsetLeft - xScrollPos + el.clientLeft
          yPosition += el.offsetTop - yScrollPos + el.clientTop
        } else {
          xPosition += el.offsetLeft - el.scrollLeft + el.clientLeft
          yPosition += el.offsetTop - el.scrollTop + el.clientTop
        }

        el = el.offsetParent
      }
      return {
        x: xPosition,
        y: yPosition
      }
    }
  }
})
export default MILESTONE_MIXIN
